export const dynamicEnvironment = {
    websiteURL: window.location.origin,
};